import {
  enabledFrameworks,
  frameworkCatalog,
  frameworkTemplate,
} from "../domain/framework-manager";
import type { SyncrelState } from "../domain/types";
import { escapeHtml } from "./render-utils";

export const renderFrameworkLibrary = (state: SyncrelState): string => {
  const enabled = enabledFrameworks(state);
  const enabledIds = new Set(enabled.map((framework) => framework.id));
  const activeId = state.workspace.activeFramework ?? enabled[0]?.id ?? "rice";
  const active = frameworkTemplate(activeId);
  const available = frameworkCatalog.filter((framework) => !enabledIds.has(framework.id));
  const categories = ["Prioritization", "Discovery", "Strategy"] as const;
  const availableGroups = categories
    .map((category) => ({
      category,
      frameworks: available.filter((framework) => framework.category === category),
    }))
    .filter((group) => group.frameworks.length > 0);

  return `
    <section class="panel panel--frameworks">
      <div class="panel-head">
        <div>
          <h2>Framework Library</h2>
          <span>${enabled.length} active tabs</span>
        </div>
      </div>
      <div class="framework-library">
        <div class="framework-tabs" role="tablist" aria-label="Active frameworks">
          ${enabled.map((framework) => `
            <div class="framework-tab ${framework.id === activeId ? "is-active" : ""}" role="presentation">
              <button type="button" role="tab" data-framework="${framework.id}" aria-selected="${framework.id === activeId ? "true" : "false"}">
                ${escapeHtml(framework.shortLabel)}
              </button>
              ${enabled.length > 1 ? `
                <button type="button" class="framework-tab__remove" data-remove-framework="${framework.id}" title="Remove ${escapeHtml(framework.label)} from tabs" aria-label="Remove ${escapeHtml(framework.label)} from tabs">×</button>
              ` : ""}
            </div>
          `).join("")}
        </div>
        <div class="framework-detail">
          <div>
            <strong>${escapeHtml(active.label)}</strong>
            <p>${escapeHtml(active.description)}</p>
          </div>
          <div class="framework-field-list" aria-label="${escapeHtml(active.label)} fields">
            ${active.fields.map((field) => `<span>${escapeHtml(field.label)}</span>`).join("")}
          </div>
        </div>
        <div class="framework-presets" aria-label="Predefined framework list">
          ${availableGroups.map((group) => `
            <section class="framework-preset-group" aria-label="${escapeHtml(group.category)} frameworks">
              <h3>${escapeHtml(group.category)}</h3>
              <div class="framework-preset-group__grid">
                ${group.frameworks.map((framework) => `
                  <article>
                    <div>
                      <strong>${escapeHtml(framework.label)}</strong>
                      <span>${escapeHtml(framework.description)}</span>
                    </div>
                    <button type="button" data-add-framework="${framework.id}">Add</button>
                  </article>
                `).join("")}
              </div>
            </section>
          `).join("") || `<div class="empty-state">All predefined frameworks are in your tabs.</div>`}
        </div>
      </div>
    </section>
  `;
};
